/* src/Holidays.jsx */
import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import FullCalendar from "@fullcalendar/react";
import dayGridPlugin from "@fullcalendar/daygrid";
import Breadcrumbs from "../../../components/Breadcrumbs";
import { companyID } from "./../../../auth";
import api from "../../../api/axios";
import { AddHoliday } from "../../../components/modelpopup/AddHoliday";
import UploadHoliday from "../../../components/modelpopup/UploadHoliday";
import DeleteModal from "../../../components/modelpopup/DeleteModal";
import * as XLSX from "xlsx";
import { formatDateInTimezone } from "../../../utils/formatDateInTimezone";
import tippy from "tippy.js";
import "tippy.js/dist/tippy.css";

const Holidays = () => {
  const [holidays, setHolidays] = useState([]);
  const [configurationHolidays, setConfigurationHolidays] = useState([]);
  const [showUploadModal, setShowUploadModal] = useState(false);
  const [holidayListDownloaded, setHolidayListDownloaded] = useState(false);
  const location = useLocation();

  const currentYear = new Date().getFullYear();
  useEffect(() => {
    const company_id = companyID();
    api
      .get(`holidays/${company_id}/${currentYear}`)
      .then((res) => {
        const calendarEvents = res?.data?.map((holiday, index) => ({
          id: `holiday-${index}`,
          title: holiday.occasion,
          date:
            holiday?.holiday_date &&
            formatDateInTimezone(holiday?.holiday_date),
          allDay: true,
          extendedProps: {
            name: holiday.occasion,
          },
        }));
        setHolidays(calendarEvents);
      })

      .catch((err) => console.error("Error fetching holidays:", err));
  }, [showUploadModal]);

  const handleEventDidMount = (info) => {
    console.log("INFO", info.event.extendedProps.name);
    tippy(info.el, {
      content: `<strong>${info.event.extendedProps.name}</strong>`,
      allowHTML: true,
    });
  };

  const fetchConfigurationHolidays = async () => {
    try {
      const res = await api.get(`configuration-holidays`);
      const holidays = res?.data?.data.map((holiday) => ({
        occasion: holiday.occasion,
        holidayDates: "",
        year: "",
      }));
      setConfigurationHolidays(holidays);
    } catch (err) {
      console.error("Error fetching configuration holidays:", err);
    }
  };

  const handleDownload = async () => {
    await fetchConfigurationHolidays();
    const worksheetData = configurationHolidays.map((holiday) => ({
      Occasion: holiday.occasion,
      HolidayDates: holiday.holidayDates,
      Year: holiday.year,
    }));

    const worksheet = XLSX.utils.json_to_sheet(worksheetData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Holidays");
    XLSX.writeFile(workbook, "Holidays.xlsx");
    setHolidayListDownloaded(true);
  };

  const countEventsPerDay = (calendarEvents) => {
    const eventCountByDate = {};

    calendarEvents.forEach((event) => {
      const date = new Date(event.date).toISOString().split("T")[0];
      eventCountByDate[date] = (eventCountByDate[date] || 0) + 1;
    });

    const resultArray = Object.entries(eventCountByDate).map(
      ([date, count]) => ({
        date,
        count,
      })
    );

    return resultArray;
  };

  return (
    <div
      className={
        location.pathname.includes("leave-dashboard") ? "" : "page-wrapper"
      }
    >
      <div
        className={
          location.pathname.includes("leave-dashboard")
            ? ""
            : "content container-fluid"
        }
      >
        {!location.pathname.includes("leave-dashboard") && (
          <Breadcrumbs
            maintitle="Holidays"
            title="Dashboard"
            subtitle="Holidays"
            name="Add Holidays"
            openModal={() => setShowUploadModal(true)}
            page="holidays"
            action="create"
          />
        )}
        <div className="card row">
          <div className="card-body col-md-12">
            <FullCalendar
              plugins={[dayGridPlugin]}
              initialView="dayGridMonth"
              events={holidays}
              height="auto"
              headerToolbar={{
                left: "prev,next",
                center: "title",
                right: "",
              }}
              eventDidMount={handleEventDidMount}
              initialEvents={holidays}
              editable={true}
              selectable={true}
              selectMirror={true}
              dayMaxEvents={true}
            />
          </div>
        </div>
      </div>
      <AddHoliday />
      {showUploadModal && (
        <UploadHoliday
          show={showUploadModal}
          setShow={setShowUploadModal}
          handleDownload={handleDownload}
          holidayListDownloaded={holidayListDownloaded}
          setHolidayListDownloaded={setHolidayListDownloaded}
        />
      )}
      <DeleteModal Name="Delete Holiday" />
    </div>
  );
};

export default Holidays;
